import React, { FC } from "react";
import { Divider } from "@material-ui/core";
import { DividerProps } from "@material-ui/core/Divider";
import mergeClasses from "classnames";
import useStyles from "./styles";

interface Props extends DividerProps {
  margin?: "wide" | "condensed";
}

const DPDivider: FC<Props> = props => {
  const classes = useStyles();
  const mergedProps = Object.assign({}, props, {
    className: mergeClasses(props.className, classes[props.margin || "wide"]),
  });
  delete mergedProps.margin;
  return <Divider {...mergedProps} />;
};

export default DPDivider;
